import AnalyzerPlaceholder from './AnalyzerPlaceholder';

/**
 * Mode d'anàlisi: marcadors del discurs.
 * En construcció. Quan hi hagi endpoint, aquest panell farà la seva pròpia
 * crida (càrrega mandrosa) amb `plainText` + `language`, gestionarà el seu
 * estat de càrrega i ressaltarà els marcadors sobre el text —reutilitzant el
 * layout de dos panells (controls + text) del mode morfològic.
 */
export interface AnalyzerPanelProps {
    task_id: string;
    plainText?: string;
    language: string;
}

export default function DiscourseMarkersPanel(_props: AnalyzerPanelProps) {
    // TODO: fetch('/v1/nlp/<discourse>', { text: plainText, language }) → ressaltar marcadors
    return <AnalyzerPlaceholder title="Discourse markers" />;
}
